import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import CompanyCard from '@/components/CompanyCard'
import Vue from 'vue'

const outsourcingCompanyCustomizationsModel = vm => ({
  title: vm.$gettext('Outsourcing Company Customizations'),
  endpoint: 'outsourcing-company-customizations',
  editInPlace: true,
  allowNew: true,
  allowDelete: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'company_id',
      label: vm.$gettext('Company'),
      editable: false,
      required: false,
      description: vm.$gettext('Which company is customizing behavior'),
      componentEdit: (value, key, item) => {
        return {
          is: CompanyAutocomplete,
          props: {
            required: false,
            restrictTo: [['relationship', 'eq', 'client']],
            preQuery: item.company ? item.company.name : null,
            disabled: !!item.id
          },
          on: {
            selected: result => {
              if (result) {
                item[key] = result.id
              } else {
                item[key] = null
              }
            }
          }
        }
      },
      formatter: (value, key, item) => {
        return item.company
          ? new Vue({
              ...CompanyCard,
              parent: this,
              propsData: {
                company: item.company,
                profilePicture: false,
                withTitles: false,
                withContact: false
              }
            }).$mount().$el.outerHTML
          : ''
      }
    },
    {
      key: 'provider_id',
      label: vm.$gettext('Provider'),
      editable: false,
      required: true,
      description: vm.$gettext('To which provider this customization applies to'),
      componentEdit: (value, key, item) => {
        return {
          is: CompanyAutocomplete,
          props: {
            required: true,
            restrictTo: [['relationship', 'eq', 'provider']],
            preQuery: item.provider ? item.provider.name : null,
            disabled: !!item.id
          },
          on: {
            selected: result => {
              if (result) {
                item[key] = result.id
              } else {
                item[key] = null
              }
            }
          }
        }
      },
      formatter: (value, key, item) => {
        return item.provider
          ? new Vue({
              ...CompanyCard,
              parent: this,
              propsData: {
                company: item.provider,
                profilePicture: false,
                withTitles: false,
                withContact: false
              }
            }).$mount().$el.outerHTML
          : ''
      }
    },
    {
      key: 'outsourcing_customization_id',
      label: vm.$gettext('Outsourcing Customization'),
      type: 'select',
      options: 'outsourcingCustomizations',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: false,
      sortable: true,
      required: true,
      description: vm.$gettext('To which type of customization this record refers to'),
      default: null
    },
    {
      key: 'value',
      label: vm.$gettext('Value'),
      editable: true,
      required: true,
      description: vm.$gettext('Value for the customization'),
      type: 'text'
    }
  ],
  includes: ['company', 'provider', 'outsourcing_customization'],
  filters: ['company_id', 'company.name', 'provider_id', 'provider.name', 'outsourcing_customization.name']
})

export default outsourcingCompanyCustomizationsModel
